function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { validateError } from '@/services/services';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
import { loginObj } from '@/services/base';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['visualization']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
var CONTROLLER_NAME = '/tbl';
var DOMAIN_DASHBOARD = '/dashboard';
var headers = {
  headers: {
    'Content-Type': 'application/json'
  }
};
export default {
  getDashboardAssignment: function getDashboardAssignment(data) {
    var _this = this;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DASHBOARD + '/get_assignments', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getDashboardAssignment) Listar accesos de un usuario.';
      return validateError(err, message, function () {
        return _this.getDashboardAssignment(data);
      });
    });
  },
  setWorkbookPermission: function setWorkbookPermission(data) {
    var _this2 = this;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DASHBOARD + '/setWorkbookPermission', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauWorkBookSendAssignment) getting aproval flow list';
      return validateError(err, message, function () {
        _this2.tableauWorkBookSendAssignment(data);
      });
    });
  },
  syncTableauWorkbook: function syncTableauWorkbook(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DASHBOARD + '/extractTableauWorkbook/', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  tableauWorkBookAddUpdate: function tableauWorkBookAddUpdate(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DASHBOARD + '/tableauWorkBookAddUpdate', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauDataSourceAddUpdate) Add or Update new role';
      return validateError(err, message, function () {
        appApisGTW.tableauWorkBookAddUpdate(data);
      });
    });
  },
  tableauWorkBookQuery: function tableauWorkBookQuery(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DASHBOARD + '/tableauWorkBookQuery', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauDataSourceQuery) Search driver connection';
      return validateError(err, message, function () {
        appApisGTW.tableauWorkBookQuery(data);
      });
    });
  },
  tableauWorkBookQueryAllDomain: function tableauWorkBookQueryAllDomain(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DASHBOARD + '/tableauWorkBookQueryAllDomain', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauWorkBookQueryAllDomain) Search All Domain';
      return validateError(err, message, function () {
        appApisGTW.tableauWorkBookQueryAllDomain(data);
      });
    });
  },
  tableauWorkBookLogQuery: function tableauWorkBookLogQuery(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DASHBOARD + '/tableauWorkBookLogQuery', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauWorkBookLogQuery) Search driver connection';
      return validateError(err, message, function () {
        appApisGTW.tableauWorkBookLogQuery(data);
      });
    });
  },
  /*
    tableauWorkBookUpdateBusinessTerm(data) {
        const login = loginObj()
        const body = { login, ...data }
        return appApis.put('/tableauWorkBookBussinesTermTable/', body).then(res => {
            return res.data
        }).catch(err => {
            const message ='(tableauWorkBookUpdateBusinessTerm) Search driver connection'
            return validateError(err, message, () => {appApis.tableauWorkBookUpdateBusinessTerm(data)})
         })
    },
    */
  tableauWorkBookInitWorkFlow: function tableauWorkBookInitWorkFlow(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DASHBOARD + '/tableauWorkBookInitWorkFlow', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauWorkBookInitWorkFlow) Search driver connection';
      return validateError(err, message, function () {
        appApisGTW.tableauWorkBookInitWorkFlow(data);
      });
    });
  },
  tableauWorkBookPendingApproval: function tableauWorkBookPendingApproval(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DASHBOARD + '/tableauWorkBookPendingApproval', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauWorkBookPendingApproval) getting aproval flow list';
      return validateError(err, message, function () {
        appApisGTW.tableauWorkBookPendingApproval(data);
      });
    });
  },
  tableauWorkBookSendAssignment: function tableauWorkBookSendAssignment(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DASHBOARD + '/tableauWorkBookSendAssignment', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(tableauWorkBookSendAssignment) getting aproval flow list';
      return validateError(err, message, function () {
        appApisGTW.tableauWorkBookSendAssignment(data);
      });
    });
  },
  massiveApprove: function massiveApprove() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_DASHBOARD, "/massive_approve"), body).then(function (response) {
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  bulkLoad: function bulkLoad() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.unlock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_DASHBOARD, "/bulk_load"), body).then(function (response) {
      return response.data;
    });
  }
};